/**
 * ZoneNode — Framework zone (group node)
 * Large labeled rectangle that accepts child nodes and auto-tags them
 */

export default function ZoneNode({ data }) {
  return (
    <div className="w-full h-full rounded-2xl border-2 border-dashed flex flex-col"
      style={{ borderColor: data.color, backgroundColor: data.color + '30' }}>
      <div className="px-4 pt-3 pb-1 flex items-center gap-3">
        <div className="w-4 h-4 rounded-full" style={{ backgroundColor: data.color?.replace('30', '') || data.color }} />
        <span className="text-5xl font-black text-gray-700/60 uppercase tracking-widest">{data.label}</span>
      </div>
      {data.description && (
        <div className="px-4 pb-2 text-base text-gray-400">{data.description}</div>
      )}
    </div>
  );
}
